import { Directive, inject, ViewContainerRef } from '@angular/core'

@Directive({
	selector: '[ngxAdHost]',
})
export class AdDirective {
	public viewContainerRef: ViewContainerRef

	constructor() {
		this.viewContainerRef = inject(ViewContainerRef)
	}
}
